import { createApp } from "vue";
import StudentRpnStatus from "./components/StudentRpnStatus.vue";
import { getMountElements, readPayload, VUE_MOUNTED_ATTRIBUTE } from "./utils/vueMount";

const MOUNT_SELECTOR = "[data-vue-student-rpn-status]";

export function initStudentRpnStatusApp(root = document) {
  const apps = [];

  for (const element of getMountElements(root, MOUNT_SELECTOR)) {
    if (element.hasAttribute(VUE_MOUNTED_ATTRIBUTE)) {
      continue;
    }

    const payload = readPayload(element);
    const app = createApp(StudentRpnStatus, {
      apiUrl: payload.apiUrl || "",
      initialStatus: payload.initialStatus || "ok",
      initialLabel: payload.initialLabel || "Uczeń realizuje RPN.",
      studentId: Number.parseInt(String(payload.studentId || "0"), 10) || 0,
      sheetId: Number.parseInt(String(payload.sheetId || "0"), 10) || 0,
    });

    app.mount(element);
    element.setAttribute(VUE_MOUNTED_ATTRIBUTE, "1");
    apps.push(app);
  }

  return apps;
}
